import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_info_circle.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_more.svg'
import _imports_3 from '@/app/ui/assets/svg/eye_gray.svg'
import _imports_4 from '@/app/ui/assets/svg/transfer-list.svg'
import _imports_5 from '@/app/ui/assets/svg/ics_o_booking.svg'


const _hoisted_1 = { class: "flex flex-col gap-1.5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "flex flex-row items-center gap-1" }
const _hoisted_4 = { class: "text-sm text-gray-lp-300" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  class: "w-4 h-4"
}
const _hoisted_7 = { class: "text-sm text-gray-lp-300" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "text-sm text-gray-lp-300" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "text-sm text-gray-lp-300" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "more_button"
}, null, -1)
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderFilterBar = _resolveComponent("HeaderFilterBar")!
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CourierTable = _resolveComponent("CourierTable")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_HeaderFilterBar, {
      dateRange: _ctx.params.dateRange,
      "onUpdate:dateRange": _cache[1] || (_cache[1] = ($event: any) => (_ctx.params.dateRange = $event)),
      search: _ctx.params.search,
      "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => (_ctx.params.search = $event)),
      shipmentType: _ctx.params.shipmentType,
      "onUpdate:shipmentType": _cache[3] || (_cache[3] = ($event: any) => (_ctx.params.shipmentType = $event)),
      disableDownloadButton: !_ctx.tableData.length,
      showShipmentType: false,
      onDownload: _ctx.onDownload,
      onSearch: _ctx.onSearch,
      onFilter: _cache[4] || (_cache[4] = () => {
          _ctx.isLoading = true;
          _ctx.onFilterShipmentType();
      }),
      onApplyDate: _cache[5] || (_cache[5] = () => {
          _ctx.isLoading = true;
          _ctx.onFilterDate();
      }),
      onResetDate: _cache[6] || (_cache[6] = () => {
          _ctx.isLoading = true;
          _ctx.onFilterDate();
      })
    }, null, 8, ["dateRange", "search", "shipmentType", "disableDownloadButton", "onDownload", "onSearch"]),
    _createVNode(_component_SummaryCard, {
      data: _ctx.summaryData,
      isOpen: _ctx.isSummaryOpen,
      "onUpdate:isOpen": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isSummaryOpen = $event)),
      startDate: _ctx.params.dateRange.start,
      endDate: _ctx.params.dateRange.end
    }, null, 8, ["data", "isOpen", "startDate", "endDate"]),
    (_ctx.errorCause)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.getCourierList
        }, null, 8, ["errorType", "onTryAgain"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (!_ctx.tableData.length && _ctx.isFiltering && !_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 0,
                icon: "ill_spot_search",
                customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFound'),
                customMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFoundHint')
              }, null, 8, ["customHeaderMessage", "customMessage"]))
            : (!_ctx.tableData.length && !_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 1,
                  icon: "ill_spot_cancel_pickup",
                  customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.noCourier'),
                  customMessage: _ctx.$t('pickupDashboard.emptyState.noCourierHint')
                }, null, 8, ["customHeaderMessage", "customMessage"]))
              : _createCommentVNode("", true),
          (_ctx.tableData.length || _ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_CourierTable, {
                key: 2,
                class: "mt-3",
                column: _ctx.column,
                tableData: _ctx.tableData,
                sortBy: _ctx.params.sortBy,
                sortDirection: _ctx.params.sortDirection,
                substractHeight: _ctx.substractHeight,
                pagination: _ctx.params.pagination,
                loading: _ctx.isLoading,
                page: _ctx.params.pagination.page,
                "onUpdate:page": _cache[9] || (_cache[9] = ($event: any) => (_ctx.params.pagination.page = $event)),
                onRequest: _ctx.getCourierList,
                onSort: _ctx.onSort
              }, {
                no: _withCtx((slotProp) => [
                  _createTextVNode(_toDisplayString(slotProp.index + 1 + _ctx.offset), 1)
                ]),
                courier_name: _withCtx((slotProp) => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode("div", {
                      title: `${slotProp.data.courierId} - ${slotProp.data.courierName}`,
                      class: "font-semibold text-sm two-line"
                    }, _toDisplayString(slotProp.data.courierId) + " - " + _toDisplayString(slotProp.data.courierName), 9, ["title"]),
                    _createVNode("button", {
                      class: "flex flex-row gap-1 text-sm text-gray-lp-600 font-medium items-center",
                      onClick: () => _ctx.whatsapp(slotProp.data.courierPhone)
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(slotProp.data.courierPhone)) + " ", 1),
                      _hoisted_2
                    ], 8, ["onClick"])
                  ])
                ]),
                crrotw: _withCtx(({index}) => [
                  _createVNode(_component_OverlayPanel, {
                    id: "courier-pickup-crrotw-container",
                    ref: "courier-pickup-crrotw",
                    class: "courier-pickup-crrotw-container",
                    alignOverlay: "",
                    horizontalAlign: "center",
                    style: _ctx.tooltipStyle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("pickupDashboard.pickUpRemaining", {
                count: _ctx.tooltipSellerCount
              })), 1)
                    ]),
                    _: 1
                  }, 8, ["style"]),
                  _createVNode("div", _hoisted_3, [
                    _createVNode("p", _hoisted_4, [
                      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("CRROTW", index)?.shipment || 0)), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.package")) + " (" + _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("CRROTW", index)?.quantity || 0)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1)
                    ]),
                    _createVNode("button", {
                      onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, _ctx.getPickupData('CRROTW', index)?.seller)),
                      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideTooltip($event)))
                    }, [
                      (_ctx.getPickupData('CRROTW', index)?.isWithinTimeLimit)
                        ? (_openBlock(), _createBlock("img", _hoisted_6))
                        : _createCommentVNode("", true)
                    ], 40, ["onMouseenter"])
                  ])
                ]),
                crrpic: _withCtx(({index}) => [
                  _createVNode("p", _hoisted_7, [
                    _createVNode("span", _hoisted_8, _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("CRRPIC", index)?.shipment || 0)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.package")) + " (" + _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("CRRPIC", index)?.quantity || 0)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1)
                  ])
                ]),
                crrdon: _withCtx(({index}) => [
                  _createVNode("p", _hoisted_9, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("CRRDON", index)?.shipment || 0)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.package")) + " (" + _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("CRRDON", index)?.quantity || 0)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1)
                  ])
                ]),
                total_pickup: _withCtx(({index}) => [
                  _createVNode("p", _hoisted_11, [
                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("ALL", index)?.shipment || 0)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.package")) + " (" + _toDisplayString(_ctx.fmtQty(_ctx.getPickupData("ALL", index)?.quantity || 0)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1)
                  ])
                ]),
                action: _withCtx(({index, data}) => [
                  _createVNode("button", {
                    onClick: (e) => _ctx.toggleActionOP(e, index)
                  }, [
                    _hoisted_13
                  ], 8, ["onClick"]),
                  _createVNode(_component_OverlayPanel, {
                    ref: `action-${index}`,
                    class: "rounded-md",
                    style: {"width":"312px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_14, [
                        _createVNode(_component_router_link, {
                          to: 
                  `/pickup-dashboard/monitoring/courier/${
                    data.courierId
                  }?${_ctx.getCourierQueryParam(data)}`
                ,
                          class: "flex flex-row gap-2 items-center text-left py-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.viewDetail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: 
                  `/pickup-dashboard/monitoring/courier/${
                    data.courierId
                  }/transfer-pickup?${_ctx.getCourierQueryParam(data)}`
                ,
                          class: "flex flex-row gap-2 items-center text-left py-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.transferPickUp")), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: 
                  `/pickup-dashboard/monitoring/courier/${
                    data.courierId
                  }/booking?${_ctx.getCourierQueryParam(data)}`
                ,
                          class: "flex flex-row gap-2 items-center text-left py-3 text-sm text-gray-lp-300 font-medium"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.booking")), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    _: 2
                  }, 1536)
                ]),
                _: 1
              }, 8, ["column", "tableData", "sortBy", "sortDirection", "substractHeight", "pagination", "loading", "page", "onRequest", "onSort"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}